import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { saveState, loadState, removeState } from "../browser-storage/browser-storage";

type InitialState = {
  lastService: String
}
const type = 'lastService'

const initialState: InitialState = {
  lastService: loadState(type)
}

export const lastServiceSlice = createSlice({
  name: type,
  initialState: initialState,
  reducers: {
    setLastService: (state, action: PayloadAction<String>) => {
      state.lastService = action.payload;
      saveState(type, action.payload)
    },
    removeLastService: (state) => {
      state.lastService = "";
      removeState(type)
    },
  },
});

// Action creators are generated for each case reducer function
export const { setLastService, removeLastService } = lastServiceSlice.actions;

export default lastServiceSlice.reducer;
